var _rect, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAlert(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Alert_Icon",
    "data-name": "Alert Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4973",
    "data-name": "Rectangle 4973",
    width: 24,
    height: 24,
    fill: "none",
    opacity: 0.629
  })), /*#__PURE__*/React.createElement("g", {
    id: "alert",
    transform: "translate(2.165 -23.639)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13008",
    "data-name": "Group 13008",
    transform: "translate(0 26.315)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13007",
    "data-name": "Group 13007",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5778",
    "data-name": "Path 5778",
    d: "M19.356,40.493,11.838,27.471a2.313,2.313,0,0,0-4.006,0L.313,40.493a2.313,2.313,0,0,0,2,3.469H17.353a2.313,2.313,0,0,0,2-3.469Zm-1,1.737a1.149,1.149,0,0,1-1.005.58H2.316A1.161,1.161,0,0,1,1.311,41.07L8.83,28.048a1.161,1.161,0,0,1,2.01,0L18.358,41.07A1.149,1.149,0,0,1,18.358,42.23Z",
    transform: "translate(0 -26.315)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13010",
    "data-name": "Group 13010",
    transform: "translate(9.258 32.066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13009",
    "data-name": "Group 13009"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4961",
    "data-name": "Rectangle 4961",
    width: 1.152,
    height: 5.762,
    fill: "#fff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13012",
    "data-name": "Group 13012",
    transform: "translate(9.066 38.98)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13011",
    "data-name": "Group 13011"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5779",
    "data-name": "Path 5779",
    d: "M236.77,355.99a.768.768,0,1,0,.768.768A.769.769,0,0,0,236.77,355.99Z",
    transform: "translate(-236.002 -355.99)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlert);
export default __webpack_public_path__ + "static/media/icon_alert.887ba849a0f7d007ebe5ccc80ec851f6.svg";
export { ForwardRef as ReactComponent };